module.exports = __webpack_public_path__ + "8c4ad3d09a8f7d6fad7bcad1a7aa8a9a.svg";